import { Chart } from '@frontend/chart/types';

export const STOCK_VOLUME_BY_PRODUCT_MONTHLY_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'Safety gloves',
            data: [
                { label: '2026-07-01', value: 280 },
                { label: '2026-08-01', value: 420 }
            ]
        },
        {
            name: 'Ear protection',
            data: [
                { label: '2026-07-01', value: 360 },
                { label: '2026-08-01', value: 310 }
            ]
        },
        {
            name: 'Safety glasses',
            data: [
                { label: '2026-07-01', value: 190 },
                { label: '2026-08-01', value: 265 }
            ]
        },
        {
            name: 'Work boots',
            data: [
                { label: '2026-07-01', value: 240 },
                { label: '2026-08-01', value: 188 }
            ]
        },
        {
            name: 'Hi-vis vest',
            data: [
                { label: '2026-07-01', value: 90 },
                { label: '2026-08-01', value: 142 }
            ]
        },
        {
            name: 'Hard hat',
            data: [
                { label: '2026-07-01', value: 130 },
                { label: '2026-08-01', value: 97 }
            ]
        },
        {
            name: 'Dust mask',
            data: [
                { label: '2026-07-01', value: 40 },
                { label: '2026-08-01', value: 54 }
            ]
        },
        {
            name: 'Knee pads',
            data: [
                { label: '2026-07-01', value: 48 },
                { label: '2026-08-01', value: 21 }
            ]
        }
    ]
};
